'use strict';

module.exports = require('has-touch')?
	{
		onMouseDown: 'onTouchStart',
		onMouseUp  : 'onTouchEnd',
		onMouseMove: 'onTouchMove'
	}:
	{
		onMouseDown: 'onMouseDown',
		onMouseUp  : 'onMouseUp',
		onMouseMove: 'onMouseMove'
	}


//////////////////
// WEBPACK FOOTER
// ./~/react-event-names/index.js
// module id = 1398
// module chunks = 0